/**
 * @generated SignedSource<<00f345c6d74667af021986fe24033fb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useHardwareUnlocksRelayQuery$variables = {
  days?: number | null | undefined;
  endTime: any;
  id: string;
  startTime: any;
};
export type useHardwareUnlocksRelayQuery$data = {
  readonly getHardware: {
    readonly id: string;
    readonly unlockSuccessRate: number | null | undefined;
    readonly unlocks: ReadonlyArray<any> | null | undefined;
  } | null | undefined;
};
export type useHardwareUnlocksRelayQuery = {
  response: useHardwareUnlocksRelayQuery$data;
  variables: useHardwareUnlocksRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "days"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endTime"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startTime"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Hardware",
    "kind": "LinkedField",
    "name": "getHardware",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "endTime",
            "variableName": "endTime"
          },
          {
            "kind": "Variable",
            "name": "startTime",
            "variableName": "startTime"
          }
        ],
        "kind": "ScalarField",
        "name": "unlocks",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "days",
            "variableName": "days"
          }
        ],
        "kind": "ScalarField",
        "name": "unlockSuccessRate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareUnlocksRelayQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useHardwareUnlocksRelayQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4c5f2f7a2055fc9c1c1ac6f2ce0d71df",
    "id": null,
    "metadata": {},
    "name": "useHardwareUnlocksRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareUnlocksRelayQuery(\n  $id: ID!\n  $startTime: DateTime!\n  $endTime: DateTime!\n  $days: Int\n) {\n  getHardware(id: $id) {\n    id\n    unlocks(startTime: $startTime, endTime: $endTime)\n    unlockSuccessRate(days: $days)\n  }\n}\n"
  }
};
})();

(node as any).hash = "e00f61e011c5506043b64d8377eaa8a8";

export default node;
